/**
 * src/db/businesses.db.js
 *
 * Datos cargados en tiempo de ejecución desde /data/businesses.json.
 * main.js llama a setBusinesses() antes de renderizar la app.
 */

export const businesses = []

export function setBusinesses(items) {
    businesses.length = 0
    businesses.push(...items)
}

function isActive(b) {
    if (b.enabled === false) return false
    const now = new Date()
    if (b.activeFrom && new Date(b.activeFrom) > now) return false
    if (b.activeTo   && new Date(b.activeTo)   < now) return false
    return true
}

export const getById       = id   => businesses.find(b => b.id === Number(id))
export const getFeatured   = ()   => businesses.filter(b => b.plan === 'oro'   && isActive(b))
export const getSilver     = ()   => businesses.filter(b => b.plan === 'plata' && isActive(b))
export const getByCategory = slug => businesses.filter(b => b.categorySlug === slug && isActive(b))
